module.exports = __webpack_public_path__ + "assets_app/img/logo_scheepstra_diap.4a0e6384.svg";